export const CASE_MANAGEMENT_SERVICE_API = "CaseManagementServiceAPI"
export const CHECK_USER_AUTHORIZATION = "/checkUserAuthorization";
export const GET_CASE_BY_STATUS_AND_OWNERSHIP = "/getCasesByStatusAndOwnership";
export const ADD_COMMENT_TO_CASE = "/addCommentToCase";
export const UPDATE_CASE_STATUS = "/updateCaseStatus";
